import momentPropTypes from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line import/no-cycle
import { CalendarMonth } from '.';

import './CalendarMonthGrid.scss';

function getMonths(initialMonth, numberOfMonths) {
  let month = initialMonth.clone();

  const months = [];
  for (let i = 0; i < numberOfMonths; i += 1) {
    months.push(month);
    if (numberOfMonths > 1) month = month.clone().add(1, 'month');
  }

  return months;
}

const CalendarMonthGrid = (props) => {
  const {
    enableOutsideDays,
    initialMonth,
    numberOfMonths,
    renderDayContents,
  } = props;

  const months = getMonths(initialMonth, numberOfMonths);
  const cn = months.length > 1 ? 'CalendarMonth__Two' : undefined;

  return (
    <div className="CalendarMonthGrid">
      {months.map((month) => (
        <CalendarMonth
          className={cn}
          enableOutsideDays={enableOutsideDays}
          key={month.format('MMMM')}
          month={month}
          renderDayContents={renderDayContents}
        />
      ))}
    </div>
  );
};

CalendarMonthGrid.propTypes = {
  enableOutsideDays: PropTypes.bool,
  initialMonth: momentPropTypes.momentObj,
  numberOfMonths: PropTypes.number,
  renderDayContents: PropTypes.func,
};

CalendarMonthGrid.defaultProps = {
  enableOutsideDays: false,
  initialMonth: moment(),
  numberOfMonths: 1,
  renderDayContents: undefined,
};

CalendarMonthGrid.displayName = 'CalendarMonthGrid';

export default CalendarMonthGrid;
